import React from 'react';
import type { SdkTableRow } from '../personal-information-protect/PersonalInformationProtectContent';

export type InlinePart = { text: string; bold?: boolean };

export type H5PolicyNode =
  | { type: 'br' }
  | { type: 'sdk-table' }
  | { type: 'h1' | 'h2' | 'h3'; text: string }
  | { type: 'p'; text?: string; parts?: InlinePart[] };

const renderParagraphContent = (node: Extract<H5PolicyNode, { type: 'p' }>) => {
  if (node.text !== undefined) {
    return node.text;
  }
  if (node.parts) {
    return node.parts.map((part, i) =>
      part.bold ? <strong key={i}>{part.text}</strong> : part.text
    );
  }
  return null;
};

export const renderH5PolicyNodes = (
  nodes: H5PolicyNode[],
  sdkTableRows?: SdkTableRow[]
): React.ReactNode[] =>
  nodes.map((node, index) => {
    if (node.type === 'br') {
      return <br key={index} />;
    }
    if (node.type === 'sdk-table' && sdkTableRows) {
      return (
        <div key={index} className="table-wrap">
          <table>
            <thead>
              <tr>
                <th scope="col">SDK名称</th>
                <th scope="col">SDK服务提供主体</th>
                <th scope="col">SDK所收集的数据类型</th>
                <th scope="col">使用SDK的目的</th>
                <th scope="col">SDK的个人信息保护政策链接地址</th>
              </tr>
            </thead>
            <tbody>
              {sdkTableRows.map((row) => (
                <tr key={row.name}>
                  <td className="cell-medium">{row.name}</td>
                  <td className="cell-medium">{row.subject}</td>
                  <td className="cell-medium">{row.dataType}</td>
                  <td className="cell-medium">{row.purpose}</td>
                  <td className="cell-large">{row.link}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
    if (node.type === 'h1') {
      return (
        <h1 key={index} className="text-align-center">
          {node.text}
        </h1>
      );
    }
    if (node.type === 'h2') {
      return <h2 key={index}>{node.text}</h2>;
    }
    if (node.type === 'h3') {
      return <h3 key={index}>{node.text}</h3>;
    }
    if (node.type === 'p') {
      const className =
        node.text && /^（20\d{2}/.test(node.text) ? 'text-align-center' : undefined;
      return (
        <p key={index} className={className}>
          {renderParagraphContent(node)}
        </p>
      );
    }
    return null;
  });
